import { translate } from 'utils/translation';

export const moduleHeader = (index, title, format, backgroundImage) => ({
  index: index || 0,
  sectionType: 'MODULE_HEADER',
  format: format || 'MODULE_2_2',
  title: title || translate('common.moduleTitle'),
  backgroundImage: backgroundImage || null,
  elements: null
});